<div [formGroup]="formRegister" class="others-documents">
  <div class="others-documents__header">
    <h4 class="others-documents__title">Outros Documentos</h4>
    <div class="others-documents__header-action">
      <b3-button
        class="others-documents__add-btn"
        type="button"
        variant="outlined"
        tone="default"
        [disabled]="validateDisabledButton()"
        (b3-click)="addAttachment()">
        <b3-icon name="add" size="sm"></b3-icon>
        Incluir novo
      </b3-button>
    </div>
  </div>

  <div class="fields-row fields-row--1">
    <div class="field-group field-group--labeled">
      <b3-input-text
        formControlName="relevantDocumentationAdd"
        inputId="linkDocument__AddOthers"
        label="Link do documento"
        background="white"
        mask="text"
        placeholder="Limite de 100 caracteres"
        [maxlength]="100">
      </b3-input-text>
    </div>
  </div>

  <h4 class="linked-documents__title">Documentos vinculados</h4>

  <div class="documents-table" *ngIf="attachmentsAdded.length > 0">
    <div class="documents-table__grid">
      <div class="documents-table__head">
        <span>Link</span>
        <span class="documents-table__cell--actions">Ações</span>
      </div>

      <div
        class="documents-table__row"
        *ngFor="let attachment of paginatedAttachments; trackBy: trackByAttachment">
        <a
          class="documents-table__link"
          [href]="attachment.link"
          target="_blank"
          rel="noopener noreferrer">
          {{ attachment.link }}
        </a>
        <div class="documents-table__cell--actions">
          <button
            type="button"
            class="documents-table__remove-btn"
            aria-label="Remover documento"
            (click)="deleteAttachment(attachment)">
            <b3-icon name="delete" size="sm"></b3-icon>
          </button>
        </div>
      </div>
    </div>

    <footer class="documents-table__footer">
      <p class="documents-table__summary">
        Mostrando {{ attachmentsAdded.length }}
        {{ attachmentsAdded.length === 1 ? 'documento' : 'documentos' }}
      </p>

      <nav
        *ngIf="totalPages > 1"
        class="documents-table__pagination"
        aria-label="Paginação de documentos vinculados">
        <button
          type="button"
          class="documents-table__page-btn"
          aria-label="Página anterior"
          [disabled]="currentPage <= 1"
          (click)="goToPage(currentPage - 1)">
          <b3-icon name="chevron_left" size="sm"></b3-icon>
        </button>
        <span class="documents-table__page-current" aria-current="page">{{ currentPage }}</span>
        <button
          type="button"
          class="documents-table__page-btn"
          aria-label="Próxima página"
          [disabled]="currentPage >= totalPages"
          (click)="goToPage(currentPage + 1)">
          <b3-icon name="chevron_right" size="sm"></b3-icon>
        </button>
      </nav>
    </footer>
  </div>

  <p class="documents-table__empty" *ngIf="attachmentsAdded.length === 0">
    Nenhum outro documento cadastrado
  </p>
</div>
